<template>
  <component
    :is="iconComponent"
    v-bind="{ size: defaultSize, ...$attrs }"
    data-testid="components-ui-sk-icon"
  />
</template>

<script setup>
import { computed, useAttrs } from 'vue'
import { icons } from '@/assets/icons/icons.js'

const attrs = useAttrs()

/**
 * @param {String} name - имя иконки (https://lucide.dev/icons/)
 * @param {Number} size - размер иконки (дефолт 18px)
 * @param {Number} strokeWidth - ширина обводки (дефолт 2px)
 * @param {String} color - цвет иконки
 */

const props = defineProps({
  name: {
    type: String,
    required: true
  }
})

const iconComponent = computed(() => icons[props.name] || null)

const defaultSize = computed(() => attrs.size || 18)
</script>
